import { handleActions } from 'redux-actions';
import { organizationReceived } from '../actions/organization';

const initialState = {
  logoUrl: '',
  backgroundImageUrl: '',
  termsOfServiceUrl: '',
  languages: ['fi', 'en'],
  googleAnalyticsTrackingId: '',
  googleTagManagerId: '',
  optionalReservationText: false,
  loginOnlyBySso: false,
  defaultLocale: '',
  relaxedSotuVerificationEnabled: false,
  employerSelectionEnabled: false,
  loginPolicyType: 'ONLY_SSN',
  smsConfirmationEnabled: false,
  emailConfirmationEnabled: false,
};

const organizationReducer = handleActions({
  [organizationReceived]: (state, action) => ({
    ...state,
    logoUrl: action.payload.logoUrl,
    backgroundImageUrl: action.payload.backgroundImageUrl,
    brandingCssUrl: action.payload.brandingCssUrl,
    reservationByCodeEnabled: action.payload.reservationByCodeEnabled,
    termsOfServiceUrl: action.payload.termsOfServiceUrl,
    languages: action.payload.locales.map(locale => locale.split('_')[0]),
    googleAnalyticsTrackingId: action.payload.googleAnalyticsTrackingId ? action.payload.googleAnalyticsTrackingId : '',
    googleTagManagerId: action.payload.googleTagManagerId ? action.payload.googleTagManagerId : '',
    optionalReservationText: action.payload.optionalReservationText,
    loginOnlyBySso: action.payload.loginOnlyBySso,
    defaultLocale: action.payload.defaultLocale,
    relaxedSotuVerificationEnabled: action.payload.relaxedSotuVerificationEnabled,
    employerSelectionEnabled: action.payload.employerSelectionEnabled,
    loginPolicyType: action.payload.loginPolicyType,
    registrationExclusiveFields: action.payload.registrationExclusiveFields,
    showOwnTeamByDefault: action.payload.showOwnTeamByDefault,
    smsConfirmationEnabled: action.payload.smsConfirmationEnabled,
    emailConfirmationEnabled: action.payload.emailConfirmationEnabled,
  })
}, initialState);

export default organizationReducer;



// WEBPACK FOOTER //
// ./src/reducers/organization.js